<template>
  <div style="background:#ffffff">
    <div v-for="(items, index1) in exportData" :key="index1" class="moudle_statement_export"
      :id="`statement_${dataInfo.account.statements_id}_${index1}`">
      <img src="@/assets/img/voided.png" v-if="dataInfo.account.is_voided == 1" class="voided" alt="">
      <div class="mainTitle">
        <h3 v-if="type == 2">MCN机构服务费结算单</h3>
        <h3 v-else>{{ dataInfo.account.party_a_name }}结算单</h3>
        <template v-if="items.length != 0">
          <div class="bothSides">甲方：{{ dataInfo.account.party_a_name }}</div>
          <div class="bothSides">乙方：{{ dataInfo.account.name }}</div>
          <div class="bothSides statementsID" style="top:100px" v-if="$route.params.id || $route.query.id">
            {{ dataInfo.account.verify_status == 0 ? '已保存' : dataInfo.account.verify_status ==
              1 ? '商务待审核' : dataInfo.account.verify_status == 2 ? '财务待审核' : dataInfo.account.verify_status ==
                3 ? '商务驳回' : dataInfo.account.verify_status == 4 ? '财务审核通过' : dataInfo.account.verify_status == 5 ? '财务驳回' :
                  '' }}</div>
        </template>
        <div class="bothSides statementsID" v-if="dataInfo.account.statements_id">序列号：{{ dataInfo.account.statements_id }}
        </div>
        <div class="bothSides statementsID" style="top:75px"
          v-if="dataInfo && dataInfo.account && dataInfo.account.applicant_time">申请时间：{{ dataInfo.account.applicant_time
          }}
        </div>
      </div>
      <!-- 游戏 -->
      <table border="1" bordercolor="#ebeef4" v-if="type == 5 && items.length != 0">
        <tr style="background:#F3E8E3">
          <th>编号</th>
          <th style="width:120px">项目</th>
          <th>记账月份</th>
          <th>实际消耗月份</th>
          <th>达人账号</th>
          <th>上线时间</th>
          <th v-if="!isHiddenHZXS">合作形式</th>
          <th>实际消耗</th>
          <th v-if="dataInfo.account.is_discount == 1">折扣率(小数)</th>
          <th v-if="dataInfo.account.is_discount == 1">折扣金额</th>
          <th>流量助推</th>
          <th>链接费</th>
          <th>置顶费</th>
          <th>价格合计</th>
        </tr>
        <template v-for="(item, index) in items">
          <tr :style="`background:#f4f7fa;height:${tr_height}px`" v-if="item.is_notes" :key="index">
            <td :colspan="isHiddenHZXS ? '6' : '7'">{{ item.sort_month }}小计</td>
            <td style="text-align: right;">{{ $formatNum(item.actual_consumption) }}</td>
            <td v-if="dataInfo.account.is_discount == 1"></td>
            <td v-if="dataInfo.account.is_discount == 1" style="text-align: right;">{{ $formatNum(item.discount_amount) }}
            </td>
            <td style="text-align: right;">{{ $formatNum(item.flow_boost_back_point) }}</td>
            <td style="text-align: right;">{{ $formatNum(item.link_fee) }}</td>
            <td style="text-align: right;">{{ $formatNum(item.top_fee) }}</td>
            <td style="text-align: right;">{{ $formatNum(item.total_amount) }}</td>
          </tr>
          <tr v-else-if="item.is_total" :key="index" :style="`height:${tr_height}px`">
            <td :colspan="isHiddenHZXS ? '6' : '7'" style="color:#393d64;font-weight:500;">总金额</td>
            <td style="text-align: right;">{{ $formatNum(dataInfo.order.total.actual_consumption) }}</td>
            <td v-if="dataInfo.account.is_discount == 1"></td>
            <td v-if="dataInfo.account.is_discount == 1" style="text-align: right;">
              {{ $formatNum(dataInfo.order.total.discount_amount) }}</td>
            <td style="text-align: right;">{{ $formatNum(dataInfo.order.total.flow_boost_back_point) }}</td>
            <td style="text-align: right;">{{ $formatNum(dataInfo.order.total.link_fee) }}</td>
            <td style="text-align: right;">{{ $formatNum(dataInfo.order.total.top_fee) }}</td>
            <td style="text-align: right;">{{ $formatNum(dataInfo.order.total.total_amount) }}</td>
          </tr>
          <tr v-else :key="index" :style="`height:${tr_height}px`">
            <td>{{ item.number_id }}</td>
            <td>{{ item.proejct_name }}</td>
            <td>{{ item.month }}</td>
            <td>{{ item.order_original_month }}</td>
            <td>{{ item.internet_celebrity_name }}</td>
            <td>{{ item.uptime }}</td>
            <td v-if="!isHiddenHZXS">{{ item.form_of_cooperation }}</td>
            <td style="text-align: right;">{{ $formatNum(item.actual_consumption) }}</td>
            <td v-if="dataInfo.account.is_discount == 1">{{ item.discount_rate }}</td>
            <td v-if="dataInfo.account.is_discount == 1" style="text-align: right;">{{ $formatNum(item.discount_amount) }}
            </td>
            <td style="text-align: right;">{{ $formatNum(item.flow_boost_back_point) }}</td>
            <td style="text-align: right;">{{ $formatNum(item.link_fee) }}</td>
            <td style="text-align: right;">{{ $formatNum(item.top_fee) }}</td>
            <td style="text-align: right;">{{ $formatNum(item.total_amount) }}</td>
          </tr>
        </template>
      </table>
      <!-- cpa -->
      <table border="1" bordercolor="#ebeef4" v-if="type == 4 && items.length != 0">
        <tr style="background:#F3E8E3">
          <th>编号</th>
          <th style="width:100px">项目</th>
          <th>记账月份</th>
          <th>实际消耗月份</th>
          <th>达人账号</th>
          <th>达人ID</th>
          <th>投放起始时间</th>
          <th>媒体名称</th>
          <th>CPA单价</th>
          <th>CPA单量</th>
          <th>结算价格合计</th>
        </tr>
        <template v-for="(item, index) in items">
          <tr :style="`background:#f4f7fa;height:${tr_height}px`" :key="index" v-if="item.is_notes">
            <td colspan='8'>{{ item.sort_month }}小计</td>
            <td>{{ $formatNum(item.cpa_unit_income_price) }}</td>
            <td>{{ item.cpa_single_quantity }}</td>
            <td>{{ $formatNum(item.total_amount) }}</td>
          </tr>
          <tr v-else-if="item.is_total" :key="index" :style="`height:${tr_height}px`">
            <td colspan='8' style="color:#393d64;font-weight:500;">总金额</td>
            <td></td>
            <td>{{ dataInfo.order.total.cpa_single_quantity }}</td>
            <td>{{ $formatNum(dataInfo.order.total.total_amount) }}</td>
          </tr>
          <tr v-else :key="index" :style="`height:${tr_height}px`">
            <td>{{ index + 1 }}</td>
            <td>{{ item.proejct_name }}</td>
            <td>{{ item.month }}</td>
            <td>{{ item.order_original_month }}</td>
            <td>{{ item.internet_celebrity_name }}</td>
            <td>{{ item.internet_celebrity_id }}</td>
            <td>{{ item.uptime }}</td>
            <td>{{ item.form_of_cooperation }}</td>
            <td>{{ $formatNum(item.cpa_unit_income_price) }}</td>
            <td>{{ item.cpa_single_quantity }}</td>
            <td>{{ $formatNum(item.total_amount) }}</td>
          </tr>
        </template>
      </table>
      <!-- mcn -->
      <table border="1" bordercolor="#ebeef4" v-if="type == 2 && items.length != 0">
        <tr style="background:#F3E8E3">
          <th>编号</th>
          <th style="width:100px">项目</th>
          <th>记账月份</th>
          <th>实际消耗月份</th>
          <th>达人账号</th>
          <th>投放周期</th>
          <th>下单金额</th>
          <th>服务费比例(小数)</th>
          <th>返点金额</th>
        </tr>
        <template v-for="(item, index) in items">
          <tr :style="`background:#f4f7fa;height:${tr_height}px`" :key="index" v-if="item.is_notes">
            <td colspan='6'>{{ item.sort_month }}小计</td>
            <td style="text-align: right;">{{ $formatNum(item.final_amount) }}</td>
            <td></td>
            <td style="text-align: right;">{{ $formatNum(item.return_point_amount) }}</td>
          </tr>
          <tr v-else-if="item.is_total" :key="index" :style="`height:${tr_height}px`">
            <td colspan='6' style="color:#393d64;font-weight:500;">总金额</td>
            <td colspan='3' style="text-align: right;">{{ $formatNum(dataInfo.order.total.return_point_amount) }}</td>
          </tr>
          <tr v-else :key="index" :style="`height:${tr_height}px`">
            <td>{{ index + 1 }}</td>
            <td>{{ item.project_name_second }}</td>
            <td>{{ item.month }}</td>
            <td>{{ item.order_original_month }}</td>
            <td>{{ item.internet_celebrity_name }}</td>
            <td>{{ item.launch_start_date }}</td>
            <td style="text-align: right;">
              <span>{{ $formatNum(item.final_amount) }}</span>
            </td>
            <td>
              {{ item.percentage_of_service_charge }}
            </td>
            <td style="text-align: right;">
              {{ $formatNum(item.return_point_amount) }}
            </td>
          </tr>
        </template>
      </table>
      <!-- pdd -->
      <table border="1" v-if="type == 6 && items.length != 0" bordercolor="#ebeef4">
        <tr style="background:#F3E8E3">
          <th>编号</th>
          <th>项目</th>
          <th>记账月份</th>
          <th>实际消耗月份</th>
          <th>达人账号</th>
          <th>上线时间</th>
          <th>合作形式</th>
          <th>实际消耗</th>
          <th>开票次数</th>
          <th>首次开票比例(小数)</th>
          <th>首次开票金额</th>
          <th>尾款开票金额</th>
          <th>价格合计</th>
        </tr>
        <template v-for="(item, index) in items">
          <tr :style="`background:#f4f7fa;height:${tr_height}px`" v-if="item.is_notes" :key="index">
            <td colspan='7'>{{ item.sort_month }}小计</td>
            <td>{{ $formatNum(item.actual_consumption) }}</td>
            <td>{{ item.billing_times }}</td>
            <td>{{ item.first_invoicing_ratio }}</td>
            <td>{{ $formatNum(item.first_invoiced_amount) }}</td>
            <td>{{ $formatNum(item.final_invoiced_amount) }}</td>
            <td>{{ $formatNum(item.total_amount) }}</td>
          </tr>
          <tr v-else-if="item.is_total" :key="index" :style="`height:${tr_height}px`">
            <td colspan='7' style="color:#393d64;font-weight:500;">总金额</td>
            <td>{{ $formatNum(dataInfo.order.total.actual_consumption) }}</td>
            <td>{{ dataInfo.order.total.billing_times }}</td>
            <td>{{ dataInfo.order.total.first_invoicing_ratio }}</td>
            <td>{{ $formatNum(dataInfo.order.total.first_invoiced_amount) }}</td>
            <td>{{ $formatNum(dataInfo.order.total.final_invoiced_amount) }}</td>
            <td>{{ $formatNum(dataInfo.order.total.total_amount) }}</td>
          </tr>
          <tr v-else :key="index" :style="`height:${tr_height}px`">
            <td>{{ index + 1 }}</td>
            <td>{{ item.proejct_name }}</td>
            <td>{{ item.month }}</td>
            <td>{{ item.order_original_month }}</td>
            <td>{{ item.internet_celebrity_name }}</td>
            <td>{{ item.uptime }}</td>
            <td>{{ item.form_of_cooperation }}</td>
            <td>{{ $formatNum(item.actual_consumption) }}</td>
            <td>{{ item.billing_times }}</td>
            <td>{{ item.first_invoicing_ratio }}</td>
            <td>{{ $formatNum(item.first_invoiced_amount) }}</td>
            <td>{{ $formatNum(item.final_invoiced_amount) }}</td>
            <td>{{ $formatNum(item.total_amount) }}</td>
          </tr>
        </template>
      </table>
      <div class="bothSidesBox clear" v-if="index1 + 1 == exportData.length">
        <div class="aParty">
          <div class="title">甲方银行账号信息如下：</div>
          <div class="infoItem">
            <label>名称：</label>
            <div class="inputDiv">{{ dataInfo.account.party_a_name }}</div>
          </div>
          <div class="infoItem">
            <label>税号：</label>
            <div class="inputDiv">{{ dataInfo.account.party_a_ein }}</div>
          </div>
          <div class="infoItem">
            <label style="vertical-align: top;">地址/电话：</label>
            <div class="inputDiv">{{ dataInfo.account.party_a_address }}</div>
          </div>
          <div class="infoItem">
            <label style="vertical-align: top;">银行/账号：</label>
            <div class="inputDiv">{{ dataInfo.account.party_a_account }}</div>
          </div>
          <div class="infoItem">
            <label style="width:100%">甲方：{{ dataInfo.account.party_a_name }}</label>
          </div>
          <div class="infoItem">
            <label>签字盖章：</label>
          </div>
          <div class="infoItem">
            <label>联系人：</label>
            <div class="inputDiv">{{ dataInfo.account.party_a_contact }}</div>
          </div>
          <div class="infoItem">
            <label>联系电话：</label>
            <div class="inputDiv">{{ dataInfo.account.party_a_phone }}</div>
          </div>
          <div class="infoItem">
            <label>日期：</label>
            <div class="inputDiv">{{ dataInfo.account.party_a_add_date }}</div>
          </div>
        </div>
        <div class="aParty">
          <div class="title">乙方银行账号信息如下：</div>
          <div class="infoItem">
            <label>账号名称：</label>
            <div class="inputDiv">{{ dataInfo.account.name }}</div>
          </div>
          <div class="infoItem">
            <label>开户银行：</label>
            <div class="inputDiv">{{ dataInfo.account.bank }}</div>
          </div>
          <div class="infoItem">
            <label>账户：</label>
            <div class="inputDiv">{{ dataInfo.account.account }}</div>
          </div>

          <div class="infoItem" style="margin-top:58px">
            <label style="width:100%">乙方：{{ dataInfo.account.name }}</label>
          </div>
          <div class="infoItem">
            <label>签字盖章：</label>
          </div>
          <div class="infoItem">
            <label>联系人：</label>
            <div class="inputDiv">{{ dataInfo.account.party_b_contact }}</div>
          </div>
          <div class="infoItem">
            <label>联系电话：</label>
            <div class="inputDiv">{{ dataInfo.account.party_b_phone }}</div>
          </div>
          <div class="infoItem">
            <label>日期：</label>
            <div class="inputDiv">{{ dataInfo.account.add_date }}</div>
          </div>
        </div>
      </div>
      <div class="pageDiv">第 {{ index1 + 1 }} 页，共 {{ page }} 页</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['dataInfo', 'type'],
  data () {
    return {
      exportData: [],
      page: 1,
      page_size: 40,
      proejct_name_length: 0, // 项目名称的长度
      tr_height: 33,//每个格子的高度
    }
  },
  computed: {
    isHiddenHZXS() { // 2023.12.19 甲方为"石家庄以岭药业股份有限公司"时，不要导出"合作形式"这列内容(- _ -)
      return this.dataInfo && this.dataInfo.account && 
        (this.dataInfo.account.party_a_name === '石家庄以岭药业股份有限公司' || 
         this.dataInfo.account.party_a_name === '广州孚马迪科技有限公司')
    },
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.exportInit()
      }, 500)
    })
  },
  methods: {
    exportInit () {
      var _this = this;
      if (!this.dataInfo || !this.dataInfo.order || !this.dataInfo.order.list) {
        return
      }
      var arr = [];
      if (this.type == 5) {
        arr = this.gameEvent()
      }
      if (this.type == 4) {
        arr = this.cpaEvent()
      }
      if (this.type == 2) {
        arr = this.mcnEvent()
      }
      if (this.type == 6) {
        arr = this.pddEvent()
      }
      // last_page_number 最后一页最多多少条；tr_height表格每条的高度；page_size每页的条数；proejct_name_length项目名字的最大长度
      let last_page_number = 0;
      if (this.proejct_name_length < 16) {
        _this.page_size = 25
        _this.tr_height = 50
        last_page_number = 18;
      } else {
        _this.page_size = 18
        _this.tr_height = 73;
        last_page_number = 10;
      }
      function lun (page_num, cb) {
        _this.page = page_num;
        _this.exportData.push(arr.slice((page_num - 1) * _this.page_size, page_num * _this.page_size))
        if (page_num * _this.page_size < arr.length) {
          lun(page_num + 1, cb)
        } else {
          if (_this.exportData[_this.exportData.length - 1].length > last_page_number) {//最后一页，如果订单大于last_page_number,重新启动一页（为了后面的甲乙方信息完整）
            _this.exportData.push([])
            _this.page = _this.page + 1;
            cb ? cb() : ''
          } else {
            cb ? cb() : ''
          }
        }
      }
      lun(this.page, () => {//页面数据完毕后，进行导出pdf操作
        this.$nextTick(() => {
          var html_arr = []
          this.exportData.forEach((item, index) => {//把每个页面的ID给html_arr，导出的时候直接取ID
            html_arr.push(`statement_${this.dataInfo.account.statements_id}_${index}`)
          })
          this.statementToPdf({//导出
            title: this.type == 2 ? 'MCN机构服务费结算单' : this.dataInfo.account.party_a_name + '结算单', html_arr: html_arr, cb: () => {
              this.$emit('exportSuccess')
            }
          })
        })
      })
    },
    gameEvent () {
      var arr = []
      this.dataInfo.order.list.forEach((item, index) => {
        item.row.forEach((item1, index1) => {
          item1.number_id = index1 + 1
        })
        if (item.row[0] && item.row[0].proejct_name && this.proejct_name_length < item.row[0].proejct_name.length) {
          this.proejct_name_length = item.row[0].proejct_name.length
        }
        arr = arr.concat(item.row)
        arr.push({
          month: item.month,
          actual_consumption: item.actual_consumption,
          discount_amount: item.discount_amount,
          flow_boost_back_point: item.flow_boost_back_point,
          link_fee: item.link_fee,
          top_fee: item.top_fee,
          total_amount: item.total_amount,
          is_notes: true
        })
      });
      arr.push({
        month: this.dataInfo.order.total.month,
        actual_consumption: this.dataInfo.order.total.actual_consumption,
        discount_amount: this.dataInfo.order.total.discount_amount,
        flow_boost_back_point: this.dataInfo.order.total.flow_boost_back_point,
        link_fee: this.dataInfo.order.total.link_fee,
        top_fee: this.dataInfo.order.total.top_fee,
        total_amount: this.dataInfo.order.total.total_amount,
        is_total: true
      })
      return arr
    },
    cpaEvent () {
      var arr = []
      this.dataInfo.order.list.forEach((item, index) => {
        item.row.forEach((item1, index1) => {
          item1.number_id = index1 + 1
        })
        if (item.row[0] && item.row[0].proejct_name && this.proejct_name_length < item.row[0].proejct_name.length) {
          this.proejct_name_length = item.row[0].proejct_name.length
        }
        arr = arr.concat(item.row)
        arr.push({
          month: item.month,
          cpa_unit_income_price: item.cpa_unit_income_price,
          cpa_single_quantity: item.cpa_single_quantity,
          total_amount: item.total_amount,
          is_notes: true
        })
      });
      arr.push({
        month: this.dataInfo.order.total.month,
        cpa_unit_income_price: this.dataInfo.order.cpa_unit_income_price,
        cpa_single_quantity: this.dataInfo.order.cpa_single_quantity,
        total_amount: this.dataInfo.order.total_amount,
        is_total: true
      })
      return arr
    },
    mcnEvent () {
      var arr = []
      this.dataInfo.order.list.forEach((item, index) => {
        item.row.forEach((item1, index1) => {
          item1.number_id = index1 + 1
        })
        if (item.row[0] && item.row[0].proejct_name && this.proejct_name_length < item.row[0].proejct_name.length) {
          this.proejct_name_length = item.row[0].proejct_name.length
        }
        arr = arr.concat(item.row)
        arr.push({
          month: item.month,
          final_amount: item.final_amount,
          return_point_amount: item.return_point_amount,
          is_notes: true
        })
      });
      arr.push({
        month: this.dataInfo.order.total.month,
        final_amount: this.dataInfo.order.final_amount,
        return_point_amount: this.dataInfo.order.return_point_amount,
        is_total: true
      })
      return arr
    },
    pddEvent () {
      var arr = []
      this.dataInfo.order.list.forEach((item, index) => {
        item.row.forEach((item1, index1) => {
          item1.number_id = index1 + 1
        })
        if (item.row[0] && item.row[0].proejct_name && this.proejct_name_length < item.row[0].proejct_name.length) {
          this.proejct_name_length = item.row[0].proejct_name.length
        }
        arr = arr.concat(item.row)
        arr.push({
          month: item.month,
          actual_consumption: item.actual_consumption,
          billing_times: item.billing_times,
          first_invoicing_ratio: item.first_invoicing_ratio,
          first_invoiced_amount: item.first_invoiced_amount,
          final_invoiced_amount: item.final_invoiced_amount,
          total_amount: item.total_amount,
          is_notes: true
        })
      });
      arr.push({
        month: this.dataInfo.order.total.month,
        actual_consumption: this.dataInfo.order.actual_consumption,
        billing_times: this.dataInfo.order.billing_times,
        first_invoicing_ratio: this.dataInfo.order.first_invoicing_ratio,
        first_invoiced_amount: this.dataInfo.order.first_invoiced_amount,
        final_invoiced_amount: this.dataInfo.order.cfinal_invoiced_amount,
        total_amount: this.dataInfo.order.total_amount,
        is_total: true
      })
      return arr
    }
  }

}
</script>
<style lang="scss" scoped>
@import "./statementDetail.scss";

.pageDiv {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 10px;
  font-size: 12px;
  color: #000;
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}

.moudle_statement_export {
  padding: 10px 40px;
  height: 1534px;
  position: relative;
}

.table td {
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/statementTemplate/exportTem.vue